import { ShipmentStatusCountShipmentStatus } from '@uturn/api/v1';
import { PickedStatus } from './types';

export const PICKED_SHIPMENT_STATUSES: PickedStatus[] = [
	PickedStatus.CONCEPT,
	PickedStatus.PUBLISHED,
	PickedStatus.QUOTED,
	PickedStatus.CARRIER_ASSIGNED,
	PickedStatus.COMPLETED,
];

// TODO: Move COST_DECLARED to CARRIER_ASSIGNED grouping once it's added to
//       the GET /groups response (not in ShipmentStatusCountShipmentStatus today).
export const SHIPMENT_STATUS_GROUPINGS: Record<
	PickedStatus,
	ShipmentStatusCountShipmentStatus[]
> = {
	[PickedStatus.CONCEPT]: [ShipmentStatusCountShipmentStatus.CONCEPT],
	[PickedStatus.PUBLISHED]: [ShipmentStatusCountShipmentStatus.PUBLISHED],
	[PickedStatus.QUOTED]: [ShipmentStatusCountShipmentStatus.QUOTED],
	[PickedStatus.CARRIER_ASSIGNED]: [
		ShipmentStatusCountShipmentStatus.CARRIER_ASSIGNED,
		ShipmentStatusCountShipmentStatus.EXECUTED,
	],
	[PickedStatus.COMPLETED]: [
		ShipmentStatusCountShipmentStatus.COMPLETED,
		ShipmentStatusCountShipmentStatus.CANCELLED,
	],
};
